export default "__VITE_ASSET__CNX8$ukq__"